import React, { Component } from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {getValoresH,getValoresM,getSumas,getCotizacion} from './reducers/todo-reducer';


class App extends Component {

  constructor(props){
    super(props);
    this.state = {
        catalogos: {
            edades : [],
            ocupacion: [],
            sumas: {},
            factor_riesgo: []
        },
        cmbSexo:"H",
        cmbEdad:18,
        cmbSA: 1,
        precio: "",
        visible:true,
        loading: false

    }
  }

  componentDidMount(){
    this.props.actions.getSumas();
    var options = [];
    
    for (var i = 18; i <= 65; i++) {
        options.push(i);
    }

    this.setState({optionsAge: options});
  }

  componentWillReceiveProps(nextProps){

    debugger

    if(nextProps.successCotizacion){
        var resultado = nextProps.successCotizacion.resultado;

        var precio = this.formatCurrency(resultado);
        
        this.setState({loading:false});
        this.setState({precio:precio});
    }
  }

  render() {
    if(!this.props.sendSumas){
        return <div>Cargando ... </div>
    }

    return (
        <div className="formulario-cotiza">
        <div className="titulo">
                Seguro Básico Estandarizado de Vida
        </div>
        <div className="contenidoFormulario">
            <div className="col-md-12 col-sm-12 col-xs-6">
                <div className="col-md-6 col-sm-6">
                    <div className="form-group">
                        <label htmlFor="cmbSexo">Sexo <span className="requiredIn">*</span></label>
                        <select className="form-control" id="cmbSexo" name="cmbSexo" onChange={this.changeValues.bind(this)}>
                            <option value="H">Hombre</option>
                            <option value="M">Mujer</option>
                        </select>
                    </div>
                </div>
            </div>
                <div className="col-md-12 col-sm-12 col-xs-6">
                <div className="col-md-6 col-sm-6">
                    <div className="form-group">
                        <label htmlFor="cmbEdad">Edad <span className="requiredIn">*</span></label>
                        <select className="form-control" id="cmbEdad" name="cmbEdad" onChange={this.changeValues.bind(this)}>
                            {
                                this.state.optionsAge ? (	
                                this.state.optionsAge.map(function(value,index){
                                    return <option value={value} key={index}>{value}</option>
                                })
                                ):null
                            }
                        </select>
                    </div>
                </div>
            </div>
               <div className="col-md-12 col-sm-12 col-xs-6">
                <div className="col-md-6 col-sm-6">
                    <div className="form-group">
                        <label htmlFor="cmbSA">Suma Asegurada <span className="requiredIn">*</span></label>
                        <select className="form-control" id="cmbSA" name="cmbSA" value={this.state.cmbSA} onChange={this.changeValues.bind(this)}>
                            {
                                this.props.sendSumas ? 

                                this.props.sendSumas.sumasAseguradas.map((value,index)=>{
                                    
                                    var valor = "";
                                    if(value !== null){
                                        valor = this.formatCurrency(value);
                                    }
                                    return <option value={index+1} key={index}>{valor}</option>
                                
                                }) : null
                            }
                        </select>
                    </div>
                </div>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-6">
                    <div className="col-md-6 col-sm-6 col-xs-12 ">
                        <div className="form-group">
                            <label htmlFor="edad">Precio (Anual) <span className="requiredIn">*</span></label>
                            <input type="text" className="form-control browser-default" value={this.state.precio} />
                        </div>
                    </div>
            </div>
    
            <div className="col-md-12 col-sm-12 col-xs-12 ">
                    <p className="text-center etiquetaIva">Los precios no incluyen IVA</p>
                    
            </div>
        </div>  

                {
                    this.state.loading ? 
                    <div className="gnp-loading">
                        <div className="circle-orange"></div>
                        <div className="circle-blue"></div>
                        <div className="logo"><img src="https://storage.googleapis.com/static-portalcorporativo.gnp.com.mx/images/site/logo_header @1x.svg" 
                        className="fr-fic fr-dib" /></div>
                    </div>
                    : null
                }

      </div>
    );
  }

  changeValues(event){
    var name = event.target.name;
    var value = event.target.value;

    if(name === "ocupacion"){
        this.handleChangeOcupacion(value);
    }
    
    this.setState({[name]:value},()=>{
        this.getPrice();
    });
  }

  getPrice(){
	
		if(this.state.cmbEdad !== 0){

			var variable2 = this.state.cmbSA;
			var sexSelected = this.state.cmbSexo;


			var peticion = {
				edad : this.state.cmbEdad,
				sexo : sexSelected,
				sumaAsegurada : variable2
			}; 

            this.setState({loading:true});
			this.props.actions.getCotizacion(peticion);
		}
	}

  formatCurrency(e){
    e = e.toString().replace(/\$|,/g, "");
    if(isNaN(e)){
        e="0";
    }

    var sign =false; 
    
    if(e === Math.abs(e)){
        sign = e;
    }else{
        e = Math.floor(100 * e + .50000000001);
        sign = e;
    }

    var cents = e % 100;
    e = Math.floor(e / 100).toString();
    if(10 > cents){
        cents = "0"+cents;
    }
    for (var t = 0; t < Math.floor((e.length - (1 + t)) / 3); t++){
         e = e.substring(0, e.length - (4 * t + 3)) + "," + e.substring(e.length - (4 * t + 3));
    }
    return (sign ? "" : "-") + "$" + e + "." + cents

}

  


}


const mapStateToProps = (state) => {
    return {
        sendValoresH: state.todoReducer.get("sendValoresH"),
        sendValoresM: state.todoReducer.get("sendValoresM"),
        sendSumas: state.todoReducer.get("sendSumas"),
        failAction: state.todoReducer.get("failAction"),
        successCotizacion: state.todoReducer.get("successCotizacion")
    };
  }
  
  
  const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({
            getValoresH : getValoresH,
            getValoresM : getValoresM,
          getSumas: getSumas,
          getCotizacion: getCotizacion
       }, dispatch)
    }
  }
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(App);



// WEBPACK FOOTER //
// ./src/App.js